import * as Actions from '../Actions/EmpresaTarefaActions';
// import _ from '@lodash';

const initialState = {
    data: null,
    error: null,
    warning: null,
    info: null
};

const EmpresaTarefaReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_EMPRESATAREFA:
            {
                return {
                    ...state,
                    data: action.payload,
                };
            }
        case Actions.EMPRESATAREFA_INFO:
            {
                return {
                    ...state,
                    info: action.payload,
                };
            }
        case Actions.EMPRESATAREFA_WARNING:
            {
                return {
                    ...state,
                    warning: action.payload,
                };
            }
        case Actions.EMPRESATAREFA_ERROR:
            {
                return {
                    ...state,
                    error: action.payload,
                };
            }
        default:
            {
                return state;
            }
    }
};

export default EmpresaTarefaReducer;
